/**
 * Created by shamim.ahsan on 10/24/2018.
 */
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {of, Observable} from 'rxjs';
import {catchError, concatMap, map, mergeMap, switchMap} from 'rxjs/operators';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { Dac6ReporterApiService } from '../../services/dac6-reporter.service';
import { CommandService } from '@core/services/command.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FileManagementService } from '@core/services/file-management.service';
import {
  EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_ACTION,
  ExcelExportSourceFileDownloadAction,
  ExcelExportSourceFileDownloadFailedAction,
  ExcelExportSourceFileDownloadSuccessAction,
  FILLING_MANAGER_FORM_EXPORT_ACTION,
  FillingManagerFormExportAction,
  FillingManagerFormExportFailedAction,
  OTHERS_TRANSMISSION_UPDATED,
  TransMissionUpdatedAction
} from '../actions/dac6-reporter.actions';
import {
  DoNothingAction,
  GET_APPLICATIONS, GET_OWNERSHIP_INFO,
  GetApplicationAction,
  GetApplicationSuccessAction, GetOwnershipInfoAction, GetOwnershipInfoSuccessAction,
  NotifyOthersAction, StartupFailedAction
} from '@shared/store/actions/particle.actions';
import {TransferBoxInfoModel} from "@shared/models/transfer-box-info.model";


@Injectable()
export class Dac6ReporterEffect {
  constructor(private actions$: Actions,
              private commandService: CommandService,
              private smartGridService: SmartGridService,
              private dac6RepoterApiService: Dac6ReporterApiService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService) {

  }

  fillingManagerFormExcelExport$ = createEffect(() => this.actions$
    .pipe( ofType(FILLING_MANAGER_FORM_EXPORT_ACTION) )
    .pipe(
      switchMap((action: FillingManagerFormExportAction) => {
        const command = action.command;
        console.log(command);
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(command)
          .pipe(
            map(responseId => {
              this.fuseSplashScreenService.hide();
              return new ExcelExportSourceFileDownloadAction(responseId.Payload);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('File Export Failed');
              return of(new FillingManagerFormExportFailedAction(error));
            })
          );
      })
    ));

  ExcelSourceFileDownload$ = createEffect(() => this.actions$
    .pipe( ofType(EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_ACTION) )
    .pipe(
      switchMap((action: ExcelExportSourceFileDownloadAction) => {
        if(action.payload && action.payload.FileId) {
          return this.fileManagementService.downloadClientFileWithId(action.payload.FileId).pipe(
            map((payload: any) => {
              this.fileManagementService.openSaveFileWindow(payload, action.payload.FileName);
              this.fuseSplashScreenService.hide();
              this.snackBarService.showInformation('File Downloaded');
              return new ExcelExportSourceFileDownloadSuccessAction(payload);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('File Export Failed');
              return of(new ExcelExportSourceFileDownloadFailedAction(error));
            })
          );
        } else {
          this.fuseSplashScreenService.hide();
          let message = 'File Export Failed';
          if(action.payload && action.payload.Message) {
            message = action.payload.Message;
          }
          this.snackBarService.showError(message);
          return of(new ExcelExportSourceFileDownloadFailedAction(action.payload));
        }
      })
    ));
  /*@Effect()
  getBaskets$ = this.actions$
    .pipe( ofType(GET_BASKET) )
    .pipe(
      mergeMap((action: GetBasketAction) => {
        return this.dac6RepoterApiService.getBaskets().pipe(
          map((payload: any) => {
            console.log('getBasket', payload);
            return new GetBasketSuccessAction(payload);
          }),
          catchError(error => of(new DoNothingAction()))
        );
      })
    );
  @Effect()
  mailAlertReceived$ = this.actions$.pipe( ofType(OTHERS_TRANSMISSION_UPDATED) )
    .pipe(
      mergeMap((action: NotifyOthersAction) => {
        return [new TransMissionUpdatedAction(action.payload)];
      })
    );
    */
}
